module.exports = __webpack_public_path__ + "static/media/search.487559ec.png";